import React from 'react'

const Error = () => {
  return (
    <div class="page error-bg" id="particles-js">
    <canvas class="error-basic-background"></canvas>
    
    <div class="error-page  ">
        <div class="container">
           
            <div class="row align-items-center justify-content-center">
                <div class="col-xxl-7 col-xl-8 col-lg-9 rectangle error-authentication ">
                    <div class="text-center authentication-style rectangle1">
                        <div class="lh-1 mb-3">
                            <span class="text-info text-large fw-bold">O</span>
                            <span class="text-success text-large fw-bold">o</span>
                            <span class="text-warning text-large fw-bold">p</span>
                            <span class="text-danger text-large fw-bold">s</span>
                        </div>
                        <span class="d-block fs-15 mb-3">&#128557;,The page you are looking for is not
                            available now.</span>
                        <p class="text-muted fw-normal">
                            We are sorry for the inconvenience, try to refresh the page another time
                        </p>

                        <a href="index.html" class="btn btn-primary"><i
                                class="ri-refresh-line align-middle me-1 d-inline-block"></i>Refresh</a>
                    </div>
                </div>
            </div>
          
        </div>
    </div>
    

</div>
  )
}

export default Error
